module.exports = __webpack_public_path__ + "static/media/socialInstagram.5dfed668.png";